import PropTypes                           from 'prop-types';
import {
  setDisplayName,
  withProps
}                                          from 'recompose';
import { MAP_RESOURCE_PROP_RESOURCE_NAME } from './mapResourceProps.const';


/**
 * HOC to map the 'resourceName' props for childComponent(s).
 *
 * This can be coupled with the following components to chain props up and down stream…
 *
 *    mapResourceName(
 *        mapResourceCollectionApiUrl(
 *            mapLoadResources()
 *        )
 *    )
 *
 * @param resourceName
 *
 * @return {function(*): *}
 */
const mapResourceName = (resourceName) =>
  (Component) => setDisplayName('MapResourceName')(
    withProps({resourceName})(Component)
  );


export const MapResourceNamePropTypes = {

  // Name of the resource.
  [MAP_RESOURCE_PROP_RESOURCE_NAME]: PropTypes.string.isRequired,

};


export default mapResourceName;


// WEBPACK FOOTER //
// ./src/components/resources/mapResourceName.js